import { AppCommand } from "../AppCommand";
import { AppCommandContext } from "../AppCommandContext";
import { AppCommandBindingEntry } from "../AppCommandBindingEntry";
import { AppCommandBinding } from "../AppCommandBinding";
import { KeyboardSensorID } from "../../../sensors/KeyboardSensorID";

export class Undo extends AppCommand
{
  initialize()
  {
    this._name = 
    {
      en: "Undo",
      de: "Rückgängig" 
    }

    this._info = 
    {
      en: "Reverts the last action, that were executed.",
      de: "Macht die letzte Aktion rückgängig, die ausgeführt wurde."    
    }

    this._shortCutEntries = 
    [
      AppCommandBindingEntry.forDesktop( 
        AppCommandBinding.primaryWith( KeyboardSensorID.Key_Z )
      )
    ]
  }

  async _execute( context:AppCommandContext<any,any> ):Promise<void>
  {
    await context.webApp.undoManager.undo();    

    return Promise.resolve();
  }
}